import { Button } from '@/common/ui/Form/Button/Button'
import { Icon } from '@/common/ui/Icon/Icon'
import { Table, TableScrollHost, Tbody, Td, Th, Thead, Tr } from '@/common/ui/Table/Table'
import { useOrgIntegrations, useRemoveIntegration } from '../model'
import type { GetIntegrationsResponse } from '@/common/types/api'
import { useCurrentOrg } from '@/app/entities/org/model'
import { Modal } from '@/common/ui/Modal/Modal'
import { useState, Fragment } from 'react'

export const IntegrationsTable = ({
    onEditIntegration,
    onClickAddIntegration,
}: {
    onEditIntegration: (integration: GetIntegrationsResponse[0]) => void
    onClickAddIntegration: () => void
}) => {
    const { data: currentOrg } = useCurrentOrg()
    const { data, isLoading, error } = useOrgIntegrations(currentOrg?.id)

    const { mutate: removeIntegration } = useRemoveIntegration()
    const [integrationToDelete, setIntegrationToDelete] = useState<string | null>(null)

    const handleEditClick = (integration: GetIntegrationsResponse[0]) => {
        onEditIntegration(integration)
    }

    const handleConfirmDelete = () => {
        if (integrationToDelete) {
            removeIntegration(integrationToDelete)
            setIntegrationToDelete(null)
            const checkbox = document.getElementById('confirm-delete-modal') as HTMLInputElement

            if (checkbox) {
                checkbox.checked = false
            }
        }
    }

    const handleCancelDelete = () => {
        setIntegrationToDelete(null)
        const checkbox = document.getElementById('confirm-delete-modal') as HTMLInputElement

        if (checkbox) {
            checkbox.checked = false
        }
    }

    return (
        <>
            <TableScrollHost className='grid-cols-2' minHeight={false} outline={false}>
                <Table border pinRows pinCols striped thBg>
                    <Thead>
                        <Tr>
                            <Th>#</Th>
                            {/* <Th>Название</Th> */}
                            <Th>Маркетплейс</Th>
                            <Th>API-Ключ</Th>
                            <Th>Действия</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        <Fragment>
                            {isLoading && (
                                <Tr>
                                    <Td colSpan={4}>Загрузка...</Td>
                                </Tr>
                            )}
                            {error && (
                                <Tr>
                                    <Td colSpan={4}>Ошибка: {error.message}</Td>
                                </Tr>
                            )}
                            {data && data.length === 0 && (
                                <Tr>
                                    <Td colSpan={4} className='text-center'>
                                        Нет добавленных интеграций
                                    </Td>
                                </Tr>
                            )}
                            {data &&
                                data.map((integration, index) => (
                                    <Tr key={index}>
                                        <Td>{index + 1}</Td>
                                        <Td>{integration.marketplace}</Td>
                                        <Td>{integration.token_preview}</Td>
                                        <Td>
                                            <Button
                                                emphasis='neutral'
                                                variant='ghost'
                                                size='lg'
                                                onClick={() => handleEditClick(integration)}
                                            >
                                                <Icon name='edit-2' size='sm' />
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))}
                        </Fragment>
                    </Tbody>
                </Table>
            </TableScrollHost>
            <Modal id='confirm-delete-modal'>
                <h3>Подтверждение редактирования</h3>
                <p>Вы уверены, что хотите редактировать эту интеграцию?</p>
                <p>Это действие нельзя будет отменить.</p>

                <div className='modal-form-actions mt-5'>
                    <Button size='xl' emphasis='negative' variant='filled' onClick={handleConfirmDelete}>
                        Редактировать
                    </Button>
                    <Button size='lg' emphasis='secondary' variant='ghost' onClick={handleCancelDelete}>
                        Отмена
                    </Button>
                </div>
            </Modal>
            {data && data.length < 2 && (
                <div className='grid-col-1'>
                    <Button emphasis='secondary' variant='ghost' size='lg' onClick={onClickAddIntegration}>
                        <Icon name='plus' size='md' />
                        Добавить интеграцию
                    </Button>
                </div>
            )}
        </>
    )
}
